// @ag-grid-community/react v30.2.1
import React from 'react';
export const BeansContext = React.createContext({});
